export const ROOT = '/InterviewsAPI';
export const LIST = `${ROOT}/getinterviewpage`;
export const EXPORT = `${ROOT}/export`;
export const GET_INTERVIEWER_DETAIL = `${ROOT}/GetInterviewerLatestDetail`;
export const GET_APPLICANT_DETAIL = `${ROOT}/GetApplicantLatestDetail`;
export const GET_STATUS = `${ROOT}/getstatus`;
export const GET_HOLIDAY_DATES = `${ROOT}/getholidaydates`;
export const FILTERED_UPDATED_APPLICANT= `${ROOT}/getfilteredupdateapplicantddl`;
export const POSITION_LEVEL = `${ROOT}/getpositionlevelddl`;
export const GET_INTERVIEW_MODE = `${ROOT}/getinterviewmode`;
